import { ValidateJSModel } from 'forms/shared/types';
import { formIncludesPvqPartB, isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { LegalPoliceOffenseModel } from './types';
import { legalPoliceOffenseItemValidator } from './validators/item';

const legalPoliceOffenseValidator: ValidateJSModel<LegalPoliceOffenseModel> = {
  // For List, validation is the same for both PVQ and non-PVQ
  List: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      if ((attributes?.HasCitationLastXYears?.value === 'Yes')
        || (attributes?.HasChargesLastXYears?.value === 'Yes')
        || (attributes?.HasProbationLastXYears?.value === 'Yes')
        || (attributes?.HasParoleLastXYears?.value === 'Yes')
        || ((attributes?.HasFelonyMoreThanXYears?.value === 'Yes') && formIncludesPvqPartB(options?.formType))
        || ((attributes?.HasChargesInvolvingFirearmsMoreThanXYears?.value === 'Yes') && formIncludesPvqPartB(options?.formType))
        || ((attributes?.HasDomesticViolenceMoreThanXYears?.value === 'Yes') && formIncludesPvqPartB(options?.formType))
      ) {
        return {
          presence: true,
          branchCollection: {
            validator: legalPoliceOffenseItemValidator,
          },
        };
      }
      return {};// PVQ but no branch item selected
    }
    return {
      presence: true,
      branchCollection: { validator: legalPoliceOffenseItemValidator }, // this will leverage the default Branch value for validation.
    };
  },
  HasCitationLastXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasChargesLastXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasProbationLastXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasParoleLastXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasFelonyMoreThanXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && formIncludesPvqPartB(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasChargesInvolvingFirearmsMoreThanXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && formIncludesPvqPartB(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  HasDomesticViolenceMoreThanXYears: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && formIncludesPvqPartB(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
};
export default legalPoliceOffenseValidator;
